$(function () {
    $('[data-table]').each(function () {
        var $el = $(this);
        var $elInfo = $('[data-table-info]', this);
        var $elFilter = $('[data-table-filter]', this);
        var $elContent = $('[data-table-content]', this);
        var $elLength = $('[data-table-length]', this);
        var $elPagintation = $('[data-table-pagination]', this);
        var $elEmpty = $('[data-table-empty]', this);
        var data = [];
        var dataShow = [];

        function init() {
            var url = $el.data('table');

            if (url === '') {
                showEmptyState();
                return;
            }

            data = fetch(url);

            if (!data.hasOwnProperty('length') || data.length == 0) {
                showEmptyState();
                return;
            }

            refreshData();
        }

        function showEmptyState() {

        }

        function refreshData() {

        }

        function getPagination() {

        }

        function nextPrevious() {

        }

        function nextPagination() {

        }

        init($el, $elInfo, $elFilter, $elContent, $elLength, $elPagintation, $elEmpty);
    });

});